import { Route, Routes } from 'react-router-dom';
import TuitionFees from '..';
import NewPayment from '../NewPayment';

const TuitionFeesContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<TuitionFees />} />
      <Route path="/create" element={<NewPayment />} />
    </Routes>
  );
};

export default TuitionFeesContainer;
